/* eslint-disable no-console */
import fingerprinter from './fingerprint';
import kount from './kount';
import { getIsAdBlockEnabled } from './adblock-detect';

async function collectDataHelper({
  env = null,
  screen,
  navigator,
  kountAccountId = null,
  kountSessionId = null,
  getFingerprint,
  getFraudSessionId,
}) {
  const { colorDepth, height: screenHeight, width: screenWidth } = screen || {};
  const { javaEnabled, language } = navigator || {};

  let fingerprint;
  let kountFraudSessionId;
  let isAdBlockEnabled;

  try {
    [isAdBlockEnabled, fingerprint, kountFraudSessionId] = await Promise.all([
      getIsAdBlockEnabled(),
      getFingerprint?.(),
      kountAccountId
        ? getFraudSessionId({
            env,
            kountAccountId,
            kountSessionId,
          })
        : undefined,
    ]);
  } catch (e) {
    console.error(e);
  }

  const data = {
    riskMetadata: {
      fingerprint: fingerprint || null,
      extraData: {
        kountFraudSessionId: kountFraudSessionId || null,
      },
      browserData: {
        colorDepth: colorDepth || null,
        isJavaEnabled: javaEnabled ? javaEnabled.call(navigator) : null,
        language: language || null,
        screenHeight: screenHeight || null,
        screenWidth: screenWidth || null,
        timeZoneOffset: new Date().getTimezoneOffset(),
        isAdBlockEnabled,
      },
    },
  };

  return data;
}

async function collectData({
  env = null,
  kountAccountId = null,
  kountSessionId = null,
} = {}) {
  return collectDataHelper({
    env,
    screen,
    navigator,
    kountAccountId,
    kountSessionId,
    getFingerprint: fingerprinter,
    getFraudSessionId: kount,
  });
}

export { collectData, collectDataHelper };
